module.exports = __webpack_public_path__ + "img/bg.9987d6a5.jpg";